import API from '../../service/api'
import API_BOOK from '../../service/endpoints'
import ActionTypes from '../actionTypes'

export const fetchBreakdownTickets = ({ registrationNumbers, type } = {}) => async (dispatch) => {
  try {
    const res = await API({
      url: API_BOOK.BREAKDOWN_TICKETS.LIST.url,
      method: API_BOOK.BREAKDOWN_TICKETS.LIST.method,
      data: { registrationNumbers, type }
    })
    if (res) {
      dispatch({ type: ActionTypes.BREAKDOWN_TICKETS.FETCH_LIST_SUCCESS, payload: res?.data?.data || [] })
    }
  } catch (error) {
    console.log('fetchBreakdownTickets error', error)
  }
}

export const fetchBreakdownTicketsSummary = () => async (dispatch) => {
  try {
    const res = await API({
      url: API_BOOK.BREAKDOWN_TICKETS.SUMMARY.url,
      method: API_BOOK.BREAKDOWN_TICKETS.SUMMARY.method
    })
    if (res) {
      dispatch({ type: ActionTypes.BREAKDOWN_TICKETS.FETCH_SUMMARY_SUCCESS, payload: res?.data?.data || {} })
    }
  } catch (error) {
    console.log('fetchBreakdownTicketsSummary error', error)
  }
}

export const fetchBreakdownTicketMap = () => async (dispatch) => {
  try {
    const res = await API({
      url: API_BOOK.BREAKDOWN_TICKETS.VEHICLE_MAP.url,
      method: API_BOOK.BREAKDOWN_TICKETS.VEHICLE_MAP.method
    })
    if (res) {
      dispatch({ type: ActionTypes.BREAKDOWN_TICKETS.FETCH_VEHICLE_MAP_SUCCESS, payload: res?.data?.data || {} })
    }
  } catch (error) {
    console.log('fetchBreakdownTicketMap error', error)
  }
}
